<template>
  <div id="verify_email_form">
    <h3 class="mb-4">
      Email not verified
    </h3>
    <p>When your account was created, you should have received an email asking you to verify your account email address. If you cannot find this email, check your spam or click 'Resend'</p>
    <form class="kt-form" @submit.prevent="resendVerificationEmail()">
      <input type="hidden" name="_token" :value="csrf">
      <div v-if="error">
        <div class="alert alert-danger" role="alert">
          {{ error }}
        </div>
      </div>

      <div v-if="success">
        <div class="alert alert-success" role="alert">
          {{ success }}
        </div>
      </div>

      <div class="form-group mb-0">
        <button class="btn btn-ss" @click="showForm('login_form')">
          Back
        </button>
        <button id="submit_resend" type="submit" class="btn btn-ss-standout">
          Resend
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import AuthFormsMixin from "VueMixins/AuthFormsMixin";
export default {
  mixins: [AuthFormsMixin],
  data() {
    return {
      form: {
        email: null,
      },
    };
  },
  methods: {
    resendVerificationEmail() {
      this.laddaButton('submit_resend');
      axios.post('/email/resend', { '_token': window.csrfToken }).then(() => {
        this.setSuccess("Resent Verification Email, Please check your inbox.");
        this.unLaddaButton('submit_resend');
      }).catch(() => {
        this.setError("Something went wrong, please contact SharpStream Support");
        this.unLaddaButton('submit_resend');
      });
    },
  },
};
</script>
